export const config = {
  mixins: [],
  data() {
    return {
      columns: []
    };
  },
  methods: {
    // 获取表格列
    getColumns() {
      let columns = [
        {
          title: '商品名称',
          align: 'center',
          slot: 'svcName',
          minWidth: 200,
        },
        {
          title: '类型',
          minWidth: 100,
          align: 'center',
          slot: 'svcCate',
        },
        {
          title: '所需积分',
          key: 'commission',
          align: 'center',
          minWidth: 80
        },
      ];
      if(this.pageType == 2) {
        columns.push({
          title: '市场价格',
          key: 'marketPrice',
          minWidth: 100,
          align: 'center'
        });
      }
      columns.push({
        title: '操作',
        align: 'center',
        slot: 'action',
        minWidth: 120
      });
      this.columns = columns;
    }
  }
};
